import { Stack, Button } from "@mui/material";

import { Link } from "react-router-dom";

const RDNavBar = (props) => {
  const path = props?.location?.pathname;

  return (
    <Stack
      direction="row"
      spacing={1}
      justifyContent="center"
      style={{ marginBottom: 10 }}
    >
      <Link
        to="/receiptDifference?action=receipt"
        style={{ textDecoration: "none", color: "black" }}
      >
        <Button
          variant="contained"
          color={path.includes("receipt/difference") ? "primary" : "inherit"}
        >
          Receipt Difference
        </Button>
      </Link>
      <Link
        to="/receipt/upload"
        style={{ textDecoration: "none", color: "black" }}
      >
        <Button
          variant="contained"
          color={path.includes("receipt/upload") ? "primary" : "inherit"}
        >
          Upload Receipt
        </Button>
      </Link>
      <Link
        to="/receiptDifference?action=convert"
        style={{ textDecoration: "none", color: "black" }}
      >
        <Button
          variant="contained"
          color={path.includes("receipt/convert") ? "primary" : "inherit"}
        >
          Receipt API
        </Button>
      </Link>
      <Link
        to="/receiptDifference?action=viewer"
        style={{ textDecoration: "none", color: "black" }}
      >
        <Button
          variant="contained"
          color={path.includes("receipt/viewer") ? "primary" : "inherit"}
        >
          Receipt Viewer
        </Button>
      </Link>
    </Stack>
  );
};

export default RDNavBar;
